export const queryKeys = {
  user: "user",
  users: "users",
  kyc: "kyc",
  withdrawal: "withdrawal",
  totalWithdrawal: "totalWithdrawal",
  savings: "savings",
  savingsType: "savingsType",
  investment: "investment",
  wallet: "wallet",
  totalInvestment: "totalInvestment",
  totalSavings: "totalSavings",
  investmentType: "investmentType",
  summary: "summary",
  account: "account",
  trans: "Transacctionns",
  log: "log",
  funding: "funding",
  investSection: "investSection",
};
